import React from "react";
import jobInHand from "../../assets/images/jobInHand.png";
import tender from "../../assets/images/tender.png";
import jobInHandWhite from "../../assets/images/jobInHandWhite.png";
import tenderWhite from "../../assets/images/tenderWhite.png";

const QuotationCreateMenu = ({ canAdd, navigateToJobInHand }) => {
  if (!canAdd) return null;

  return (
    <div className="text-right">
      <div className="dropdown">
        <button
          className="btn add-new-btn"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Add New <i className="fas fa-chevron-down ml-2"></i>
        </button>
        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <ul>
            <li onClick={() => navigateToJobInHand(1)}>
              <span>
                <img src={jobInHand} className="blue-img" alt="Job in hand" />
                <img src={jobInHandWhite} className="white-img" alt="Job in hand" />
                Job In Hand
              </span>
            </li>
            <li onClick={() => navigateToJobInHand(2)}>
              <span>
                <img src={tender} className="blue-img" alt="Tender" />
                <img src={tenderWhite} className="white-img" alt="Tender" />
                Tender
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default React.memo(QuotationCreateMenu);
